import { resolveShiftTimeZone } from '../../core/shifts/shiftTimeZone';

import { buildDailyBoard } from '../../core/shifts/shiftDailyBoard';
// Presentation only: inputs must already be authorized and scoped.
export function buildEnterpriseVisibility({ shifts = [], facilities = [], tenants = [], selectedDayMs, now = Date.now() }) {
  shifts = shifts.map(shift => ({...shift, timeZone: resolveShiftTimeZone(shift, facilities.find(f => (f.id || f.facilityId) === shift.facilityId && f.tenantId === shift.tenantId), tenants.find(t => (t.tenantId || t.id) === shift.tenantId))}));
  const board = buildDailyBoard({ shifts, selectedDayMs, now });
  const portfolio = facilities.map(facility => {
    const id = facility.id || facility.facilityId;
    const facilityBoard = buildDailyBoard({ shifts: shifts.filter(shift => shift.facilityId === id && shift.tenantId === facility.tenantId), selectedDayMs, now });
    return { id, tenantId: facility.tenantId, name: facility.name || facility.facilityName || id, board: facilityBoard };
  });
  return { board, portfolio };
}

